var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPage)?_c('Layout',[_c('template',{slot:"main"},[_c('el-main',{staticClass:"home-main-container"},[_c('Map')],1)],1)],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }